import { Icon, IconButton, Input, Modal } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import CameraAltIcon from "@material-ui/icons/CameraAlt";
import PropTypes from "prop-types";
import React from "react";
import { translate } from "react-i18next";
import ImageGallery from "react-image-gallery";
import { connect } from "react-redux";
import "../../css/react-image-gallery.css";
import "../../css/serviceAlbum.css";
import { getOriginalImage, isJsonString } from "../../utils/setting";
import { getThumbnaiImage } from "../../utils/storage";
import { style } from "./style";

class Gallery extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openModal: false,
      selectImage: "",
      imageDelete: [],
      serviceAlbum: [],
      startIndex: 0,
      showIndex: false,
      showBullets: true,
      infinite: true,
      showThumbnails: false,
      showFullscreenButton: false,
      showGalleryFullscreenButton: false,
      showPlayButton: false,
      showGalleryPlayButton: true,
      showNav: true,
      isRTL: false,
      slideDuration: 450,
      slideInterval: 2000,
      thumbnailPosition: "bottom",

      imageGallery: isJsonString(this.props.imageGallery)
        ? this.getThumnailList(JSON.parse(this.props.imageGallery))
        : [],
      showingIndex: -1,
      imageArr: [],
    };
    this.handleSelectImage = this.handleSelectImage.bind(this);
  }
  getThumnailList = (imageGallery) => {
    if (imageGallery && Array.isArray(imageGallery))
      return imageGallery.map((image, index) => {
        return getThumbnaiImage(image);
      });
    else return [];
  };
  async componentDidMount() {
    this.props.onRef(this);
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.imageGallery !== this.props.imageGallery)
      this.setState({
        imageGallery: isJsonString(nextProps.imageGallery)
          ? this.getThumnailList(JSON.parse(nextProps.imageGallery))
          : [],
      });
  }
  handleOpenModal = (url, index) => {
    this.setState({
      openModal: true,
      selectImage: url,
      startIndex: index,
      showingIndex: index,
    });
  };

  handleCloseModal = () => {
    this.setState({ openModal: false, showingIndex: -1 });
  };

  deleteImage = (index) => {
    let { imageDelete, imageArr } = this.state;
    let deleteItem = imageArr[index];
    imageDelete.push(deleteItem);
    imageArr.splice(index, 1);
    this.setState({ imageDelete: imageDelete, imageArr: imageArr });
  };
  async handleSelectImage(e) {
    let { imageArr } = this.state;
    let file = e.target.files[0];
    let reader = new FileReader();
    let _this = this;
    reader.onload = function (r) {
      imageArr.push({
        file: file,
        data: r.target.result,
      });
      _this.setState(imageArr);
    };
    reader.readAsDataURL(file);
  }

  onSlide = (index) => {
    this.setState({ showingIndex: index });
  };
  getOriginalImage = (allImage, showingIndex) => {
    return allImage.map((e, index) => {
      if (showingIndex === index) return getOriginalImage(e);
      return;
    });
  };
  getImageLibrary = () => {
    return {
      imageArr: this.state.imageArr,
      imageDelete: this.state.imageDelete,
    };
  };
  render() {
    const { classes } = this.props;
    const { showingIndex, imageArr } = this.state;
    return (
      <div className={classes.root}>
        <Modal
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          open={this.state.openModal}
          onClose={this.handleCloseModal}
        >
          <ImageGallery
            ref={(i) => (this._imageGallery = i)}
            items={imageArr.map((e) => {
              return {
                original: e.data,
                thumbnail: e.data,
              };
            })}
            startIndex={this.state.startIndex}
            lazyLoad={false}
            infinite={this.state.infinite}
            showBullets={this.state.showBullets}
            showFullscreenButton={
              this.state.showFullscreenButton &&
              this.state.showGalleryFullscreenButton
            }
            showPlayButton={
              this.state.showPlayButton && this.state.showGalleryPlayButton
            }
            showThumbnails={this.state.showThumbnails}
            showIndex={this.state.showIndex}
            showNav={this.state.showNav}
            isRTL={this.state.isRTL}
            thumbnailPosition={this.state.thumbnailPosition}
            slideDuration={parseInt(this.state.slideDuration)}
            slideInterval={parseInt(this.state.slideInterval)}
            additionalClass="app-image-gallery"
            onSlide={this.onSlide}
          />
        </Modal>
        <div className={classes.container}>
          <div className={classes.listItem}>
            <IconButton
              className={classes.buttonIcon}
              onClick={() => document.getElementById("add-image").click()}
              aria-label="Add"
            >
              {/* <Icon className={classes.icon} color="primary" >
                                        add_circle
                                    </Icon>    */}
              <CameraAltIcon className={classes.icon} />
            </IconButton>
            <Input
              className={classes.inputImage}
              disableUnderline
              id="add-image"
              type="file"
              margin="none"
              onChange={this.handleSelectImage}
            />
            <div
              className={classes.imageItem}
              style={{ backgroundImage: "url(`/images/noneImage.svg`)" }}
            ></div>
          </div>
          {imageArr &&
            imageArr.length > 0 &&
            imageArr.map((tile, index) => (
              <div className={classes.listItem + " list-item-image-album"}>
                <div className="bg-hover-image-album">
                  <div className="bg-hover-image-album-icon">
                    <IconButton
                      className={classes.buttonHover + " f-left"}
                      onClick={() => this.handleOpenModal(tile.data, index)}
                      aria-label="Zoom"
                    >
                      <Icon
                        className={classes.iconHover + " fa fa-arrows-alt"}
                        color="inherit"
                      />
                    </IconButton>
                    <IconButton
                      className={classes.buttonHover + " f-right"}
                      onClick={() => this.deleteImage(index)}
                      aria-label="Delete"
                    >
                      <Icon
                        className={classes.iconHover + " fa fa-trash"}
                        color="inherit"
                      />
                    </IconButton>
                  </div>
                </div>
                <div className={classes.imageItem}>
                  <img
                    className={classes.imageItem}
                    src={tile.data || `/images/noneImage.svg`}
                    alt="item lib"
                  />
                </div>
              </div>
            ))}
        </div>
      </div>
    );
  }
}

Gallery.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

const mapState = (state) => ({});

const mapDispatch = (dispatch) => ({});

export default connect(
  mapState,
  mapDispatch
)(translate("translations")(withStyles(style, { withTheme: true })(Gallery)));
